<template>
  <div></div>
</template>

<script>
export default {
  name: "index",
  mounted() {
    const token = this.$route.query.t
    localStorage.setItem("Authorization", `Bearer ${token}`)
    localStorage.setItem("auth-token", token)
    this.$router.replace("/chatbot")
  }
}
</script>

<style scoped>

</style>
